import {tokens} from '@commercial-helios/ui/theme'
import styled from 'styled-components'

import Image from '@helios/shared/components/image'
import {focusStyles} from '@helios/shared/styles/utils'
import mq from '@helios/shared/utils/media-query'

export const ImageContentWrapper = styled.div`
    display: grid;
    row-gap: ${tokens.spacing20};
    width: 100%;
    align-content: start;
    padding-top: ${tokens.spacing2};

    a {
        display: block;
    }

    a:focus {
        ${focusStyles()}
        border-radius: ${tokens.arc4};
    }

    a:focus img {
        border-radius: ${tokens.arc4};
    }
`

export const ContentWrapper = styled.div`
    display: grid;
    row-gap: ${tokens.spacing10};
    align-content: flex-start;
`

export const mobileBreakpoint = 'xs'

export const StyledImage = styled(Image)<{$hideOnMobile: boolean}>`
    display: ${(props) => (props.$hideOnMobile ? 'none' : 'block')};
    width: 100%;
    height: 200px;
    object-fit: cover;

    ${mq.min(mobileBreakpoint)} {
        display: block;
    }
`

export const Details = styled.div`
    display: grid;
    grid-auto-flow: column;
    justify-content: start;
    align-items: center;
    column-gap: ${tokens.spacing10};
`

export const DetailsSeparator = styled.span`
    width: 4px;
    height: 4px;
    background: ${tokens.shade600};
    border-radius: ${tokens.circle};
`
